import { useState } from 'react';
import styled from 'styled-components';
import { Confirmation_, Main_ } from 'monica-alexandria';
import { useTranslation } from 'react-i18next';
import { get_offer_creation_context } from '../../../services/api/Offers';

const OfferCreationAction = styled.div`display: grid; gap: 1.2rem;`;
const ErrorText = styled.p`color: var(--error);`;

export default function Offer_Creation_Action(props) {
    const { t } = useTranslation();
    const [checking, setChecking] = useState(false);
    const [error, setError] = useState('');
    const [replacement, setReplacement] = useState(null);
    const submit = async () => {
        if (checking || props.saving || props.disabled) return;
        setChecking(true); setError('');
        try {
            const response = await get_offer_creation_context(props.offer);
            const context = response.data.data;
            if (!props.fakeOffer && !context.normalAllowed) setError(context.restriction);
            else if (context.activeOffer) setReplacement(context.activeOffer);
            else props.onCreate(null);
        } catch (failure) { setError(failure.response?.data?.message || t('Could not verify offer eligibility.')); }
        finally { setChecking(false); }
    };
    return (
        <OfferCreationAction>
            {props.fakeOffer ? <p>{t('Fake offers total €0 and activate services without recording a payment.')}</p> : null}
            {error ? <ErrorText role="alert">{t(error)}</ErrorText> : null}
            <Main_ text={checking ? t('Checking offer eligibility...') : props.saving ? t('Creating offer...') : props.fakeOffer ? t('Create fake offer') : props.text}
                disabled={checking || props.saving || props.disabled} onClick={submit}></Main_>
            {replacement ? <Confirmation_
                message={t('This brand already has active offer {{offer}}. Proceeding will replace it and mark it Old / Canceled. Normal offers replace it after payment is confirmed.', { offer: replacement.code })}
                yes={t('Confirm replacement')} no={t('Cancel')}
                onClose={() => setReplacement(null)} onNo={() => setReplacement(null)} onYes={() => {
                    const confirmed = { offerId: replacement.offerId, version: replacement.version };
                    setReplacement(null); props.onCreate(confirmed);
                }}></Confirmation_> : null}
        </OfferCreationAction>
    );
}
